import he from 'he';
import fp from 'lodash/fp';
import { pageLayouts, pageSizes } from '../constants';
import { fullName } from '../services';
import { downloadBlobStreamFile, getBlobStream, getCsvStream, getPdfStream, noCapMap, writeDataToCsvStream, writeDataToPdfStream } from '../utils';
import { reportHeader, table } from './partials';

const tableOffset = { x: 0, y: 60 };

const trainingPlanReport = ({
  user,
  userIndustryCpdCategorys,
  cpdCategorys,
  goals,
  fromDate,
  toDate
}) => {
  const cpdCategoryRows = cpdCategorys.filter(
    ({ cpdCategory }) => fp.find(
      ({ id, parentCpdCategoryId }) => id === cpdCategory.id && !parentCpdCategoryId
    )(userIndustryCpdCategorys)
  ).map(
    ({ cpdCategory, cpdPoints }) => {
      const parent = {
        name: he.decode(cpdCategory.name),
        points: cpdPoints.toString()
      }
      const children = cpdCategorys.filter(
        (child) => fp.find(
          ({ id, parentCpdCategoryId }) => id === child.cpdCategory.id && parentCpdCategoryId === cpdCategory.id
        )(userIndustryCpdCategorys)
      ).map(
        (child) => ({
          name: `    ${he.decode(child.cpdCategory.name)}`,
          points: child.cpdPoints.toString()
        })
      )
      return [parent].concat(children)
    }
  ).flat()
  const goalRows = goals.map(
    ({ name, points }) => ({
      name: he.decode(name),
      points: points.toString()
    })
  )
  const trainingPlanRows = [
    ...cpdCategoryRows,
    ...goalRows
  ]
  return [
    ...reportHeader({
      report: 'Training Plan Report',
      reportee: `${fullName(user)} Training Plan Details`,
      minDate: fromDate,
      maxDate: toDate
    }),
    ['translate', fp.values(tableOffset)],
    ...table({
      pageLayout: pageLayouts.landscape,
      pageSize: 'A4',
      remainingPageHeight: fp.get(
        `A4.x`
      )(pageSizes) - (tableOffset.y),
      reportHeader: [
        ...reportHeader({
          report: 'Training Plan Report',
          reportee: `${fullName(user)} Training Plan Details`,
          minDate: fromDate,
          maxDate: toDate
        }),
        ['translate', [0, tableOffset.y]]
      ],
      headerRow: {
        colour: '#1fd1a1',
        text: {
          colour: '#fff'
        },
        columns: [
          { text: 'CPD Category' },
          { text: 'CPD Points' }
        ]
      },
      rows: noCapMap(
        ({
          name,
          points
        }, index) => ({
          colour: index % 2 === 0 ? '#fff' : '#EFEFEF',
          columns: [
            { text: name },
            { text: `      ${points}` }
          ]
        })
      )(trainingPlanRows)
    })
  ]
}

export const exportTrainingPlanReportPdf = (data) => {
  const {
    firstName,
    lastName
  } = data.user
  downloadBlobStreamFile(writeDataToPdfStream(
    getPdfStream({
      layout: pageLayouts.landscape,
      size: 'A4'
    }),
    trainingPlanReport(data)
  ).pipe(getBlobStream()), `${firstName}-${lastName}-training-plan.pdf`)
}

export const exportBusinessTrainingPlanReportCSV = ({
  business,
  trainingPlans,
  cpdCategorys,
  goals
}) => {
  const cpdCategoryColumns = cpdCategorys.map(
    ({ name }) => he.decode(name)
  )
  const goalColumns = goals.map(
    ({ name }) => he.decode(name)
  )
  const columns = ['Name'].concat(cpdCategoryColumns).concat(goalColumns)
  const rows = fp.map(
    ({
      user,
      ...rest
    }) => {
      const cpdCategoryData = cpdCategorys.map(
        ({ id }) => fp.flow(
          fp.get('cpdCategorys'),
          fp.find(
            ({ cpdCategory }) => cpdCategory.id === id
          ),
          fp.getOr(0)('cpdPoints')
        )(rest).toString()
      )
      const goalData = goals.map(
        ({ id }) => fp.flow(
          fp.get('goals'),
          fp.find(
            ({ goalId }) => goalId === id
          ),
          fp.getOr(0)('points')
        )(rest).toString()
      )
      const row = [fullName(user)].concat(cpdCategoryData).concat(goalData)
      return row
    }
  )(trainingPlans)
  downloadBlobStreamFile(writeDataToCsvStream(getCsvStream({
    header: true,
    columns
  }), rows).pipe(getBlobStream()), `${business.name}-training-plan.csv`)
}


// WEBPACK FOOTER //
// ./src/reports/export-training-plan-report-pdf.js